/* eslint-disable complexity */
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { ProgressIndicator } from "@asosteam/asos-web-component-library-progress-indicator";
import styles from "./Button.module.css";

export default function Button({
  children,
  disabled = false,
  href,
  loading = false,
  onClick,
  size = "large",
  style = "white",
  target,
  text,
}) {
  const className = classNames({
    [`${styles.button}`]: true,
    [`${styles[size]}`]: true,
    [`${styles[style]}`]: true,
  });
  const Component = href ? "a" : "button";

  if (!text && !children) return null;

  if (loading) {
    return <ProgressIndicator size="small" progressMessage="loading" />;
  }

  const props = {
    ...(href && { href }),
    ...(target && { target }),
    ...(onClick && { onClick }),
  };

  return (
    <Component className={className} {...props} disabled={disabled}>
      {text || children}
    </Component>
  );
}

Button.propTypes = {
  children: PropTypes.node,
  disabled: PropTypes.bool,
  href: PropTypes.string,
  loading: PropTypes.bool,
  onClick: PropTypes.func,
  size: PropTypes.oneOf(["small", "medium", "large"]),
  style: PropTypes.oneOf(["white", "black", "grey"]),
  target: PropTypes.string,
  text: PropTypes.string,
};
